import {Action} from "@thoughtspot/visual-embed-sdk";

const apiBaseUrl = "https://dev-api-v2.vinemeds.com";

export const environment = {
    production: false,
    apiBaseUrl: apiBaseUrl,
    apiUrl: `${apiBaseUrl}/v2`,
    awsDashboardPublicUrl: "",

    thoughtSpotConfig: {
        apiBaseUrl: "https://vinemeds.thoughtspot.cloud",
        defaultRecordSize: 50,

        fullEmbeds: [
            { name: "VineMeds Search", icon: "bi-search", routerLink: "/analytics/search", featureFlag: null },
            { name: "VineMeds Full Embed", icon: "bi-window-sidebar", routerLink: "/analytics/fullapp", featureFlag: "ThoughtSpotFullEmbed" }
        ],
        hiddenVisualizations: [
            "e56972ec-fda6-4341-b5c9-ec881ac88b13"
        ],
        pinnedVisualizationId: "e56972ec-fda6-4341-b5c9-ec881ac88b13",

        searchPageActions: [
            Action.AddFormula,
            Action.AnswerChartSwitcher,
            Action.AxisMenuRename,
            Action.ChooseDataSources,
            Action.CreateLiveboard,
            Action.CopyToClipboard,
            Action.Pin,
        ],

        defaultVisibleActions: [
            Action.Download,
            Action.CopyToClipboard,
            Action.DownloadAsPng,
            Action.DownloadAsPdf,
            Action.DownloadAsCsv,
            Action.DownloadAsXlsx,
            Action.DrillDown,
            Action.Explore,
            Action.LiveboardInfo,
            Action.Present,
            Action.Schedule,
            Action.SchedulesList,
            Action.ShowUnderlyingData,
        ],

        additionalVisibleActions: [
            Action.AddFilter,
            Action.AddFormula,
            Action.AnswerChartSwitcher,
            Action.AnswerDelete,
            Action.ConfigureFilter,
            Action.Edit,
            Action.EditTitle,
            Action.EditDetails,
            Action.Remove,
            Action.RenameModalTitleDescription,
            Action.Save,
            Action.ToggleSize,
            Action.Share
        ],
    }
};
